import { AttachmentTypes } from "../Constants";

export default class Attachment {
  file: File | undefined = undefined;
  description: string = "";
  type: string = AttachmentTypes.DEFAULT;

  public constructor(init?: Partial<Attachment>) {
    Object.assign(this, init);
  }

  get fileName(): string {
    if (this.file !== undefined) return this.file.name;
    else return "";
  }
}
